
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    name: 'SectionSmallHero',
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
      loggedIn: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    serverCacheKey(props) {
      let cacheKey = 'section-small-hero-' + props.section.id;

      if (props.section.organization_id) {
        cacheKey += '-' + props.section.organization_id;
      }

      // Ansonsten generiere einen eindeutigen Cache-Schlüssel
      return cacheKey;
    },
    data() {
      return {
        imageUrl: process.env.NUXT_ENV_FALLBACK_SMALL_HERO_IMAGE_STATIC,
        logoUrl: process.env.NUXT_ENV_FALLBACK_SMALL_HERO_IMAGE_STATIC,
      };
    },
    created() {
      const imageUrl = this.section.image
        ? (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) &&
          this.section.image.formats.medium &&
          this.section.image.formats.medium.url
          ? this.section.image.formats.medium.url
          : this.section.image.url
        : false;

      if (imageUrl) {
        this.imageUrl = prepareImageUrl(imageUrl);
      }

      if (this.section.logo) {
        this.logoUrl = prepareImageUrl(this.section.logo.url);
      }
    },
  };
